import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { GOOGLE } from '../globals/config';
import { I18N, API_KEY } from '../globals/wp';
import { getMapLinkForLocation } from '../utils/data/location-toolbox';
import { qaReportDirectionsClick } from '../utils/data/analytics';

import styles from './results-list.pcss';

export default class ResultsList extends PureComponent {
	static propTypes = {
		locations: PropTypes.array,
	};

	static defaultProps = {
		locations: [],
	};

	locationImage(location) {
		const { lat, lng, address } = location;
		const src = `${GOOGLE.static_url}?center=${lat},${lng}&markers=color:blue|${address}&style=feature:poi|visibility:off&key=${API_KEY}&size=600x413`;
		return <img src={src} className={styles.img} alt={address} />;
	}

	getAwardsList(location) {
		if (!location.awards || location.awards.length===0) {
			return;
		}
		const awards = _.map(location.awards, award=> (
			<li className={styles.awardsItem} key={location.ID}>
				<img src={award.image_src} className={styles.awardImage} alt={award.description} />
			</li>
		));
		return (<ul className={styles.awardsList}>{awards}</ul>);
	}

	handleMapsLink = (location) => {
		qaReportDirectionsClick(location.title);
	};

	results() {
		return _.map(this.props.locations, location => {
			const mapLink = getMapLinkForLocation(location);
			return (
				<article className={styles.location} key={location.ID}>
					<div className={styles.image}>
						<a className={styles.imageLink} href={mapLink} target="_blank" onClick={() => {this.handleMapsLink(location)}}>
							{this.locationImage(location)}
						</a>
					</div>
					<div className={styles.info}>
						<h4 className={styles.heading}>
							<a className={styles.headingLink} href={location.link} dangerouslySetInnerHTML={{__html:location.title}} />
						</h4>
						<a className={styles.schoolUrl} href={location.link}>
							{location.link}
						</a>
						<address className={styles.address}>
							<a href={mapLink} target="_blank" onClick={() => {this.handleMapsLink(location)}}>
								{location.address}
							</a>
						</address>
						<div className={styles.hours}>{location.hours}</div>
						<a className={styles.phone} href={`tel:${location.phone}`}>{location.phone}</a>
						<div>
							<a href={mapLink} className={styles.directionLink} target="_blank" onClick={() => {this.handleMapsLink(location)}}>
								{I18N.location_address_label}
							</a>
						</div>
						{this.getAwardsList(location)}
					</div>
				</article>
			)
		});
	}

	noResults() {
		return <article className={styles.noResults}>{I18N.no_results}</article>;
	}

	render() {
		return (
			<section className={styles.container}>
				{this.props.locations.length ? this.results() : this.noResults()}
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/results-list.js